import { GraphSchema } from '@ta/server';

import { Status } from 'src/app/services/user/dto/user';

import { Owner } from './owner';
import { Tenant } from './tenant';

export { Status };

export interface User {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  picture: string;
  dateOfBirth: string;
  createdDate: string;
  status?: Status;
  phoneNumber: string;
  owner?: Owner;
  tenant?: Tenant;
  bailoId?: string;
  trustScore?: number;
}

export const userProps = new GraphSchema<User>([
  'id',
  'firstname',
  'lastname',
  'email',
  'picture',
  'dateOfBirth',
  'createdDate',
  'phoneNumber',
  'tenant',
  'owner',
  'status',
  'bailoId',
  'trustScore',
]);
